export enum SortingSymbol {
  ascending = '%2B',
  descending = '%2D',
}
